import type { UseMutateFunction } from '@tanstack/react-query';
import type { AxiosError, AxiosResponse } from 'axios';
import type { FieldValues } from 'react-hook-form';
import type { FormDefinition } from '@gov-design-system-ce/react-form-core';
import type { IUseBoolean } from '@gov-nx/utils/common';

export interface ContactDataSection<FormData extends FieldValues> {
	tooltipText: string;
	isReloading: boolean;

	formDefinition: FormDefinition<FormData>;
	valueVerified?: string;
	isDeleteConfirmationOpen: IUseBoolean;
	isEditing: IUseBoolean;
	isNeedForVerification: boolean;
	isLowAuthorization: boolean;
	isAuthorizationEnforced: boolean;

	onResendVerification?: () => void;
	isVerificationResending: boolean;

	onChange: () => void;
	isChanging: IUseBoolean;

	onDelete: () => void;
	isDeleting: boolean;

	onSubmit: () => void;
	onPersonalContactsUse: (value: string) => void;
	isUpdating: boolean;
	isFormOpen: boolean;
}

export interface UpdateContactHook<FormData> {
	update: UseMutateFunction<void, AxiosError, FormData>;
	isUpdating: boolean;

	verify: UseMutateFunction<AxiosResponse<void>, AxiosError, FormData>;
	isVerifying: boolean;

	delete: UseMutateFunction<void, AxiosError>;
	isDeleting: boolean;

	resendVerification: UseMutateFunction<void, AxiosError>;
	isVerificationResending: boolean;
}

type ROSSource = { source: 'ROS'; ico: number };
type ROBSource = { source: 'ROB' };
export type ContactSource = ROSSource | ROBSource;

export const isROSSource = (
	source: ROSSource | ROBSource
): source is ROSSource => source.source === 'ROS';
